/** Globale Einstellungen von OrderCity, gepflegt im Dashboard. */
/** Aufschlag auf den Stoff-EK für den EK der Filialen – 0 bis 50 % in 5er-Schritten. */
export const STOFF_AUFSCHLAG_STUFEN = [0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50];
/** Gilt, solange nichts gepflegt ist – wie der Standard-Aufschlag der Hersteller. */
export const STOFF_AUFSCHLAG_STANDARD = 30;
export function istStoffAufschlag(wert) {
    return typeof wert === "number" && STOFF_AUFSCHLAG_STUFEN.includes(wert);
}
//# sourceMappingURL=einstellungen.js.map